<script setup lang="ts">
import Button from '@/components/design-system/button.vue';

interface ICategoryErrorProps {
  returnRoute?: string;
}

const router = useRouter();

const props = withDefaults(defineProps<ICategoryErrorProps>(), {
  returnRoute: '/',
});
</script>

<template>
  <div
    class="container text-base-priority font-bold my-2 flex-center flex-col min-h-[30vh]"
  >
    <div class="m-3 text-xl text-center">
      {{ $t('jpc.no-games-error-message') }}
    </div>
    <Button
      class="mb-3 uppercase mx-auto"
      @click="router.push(props.returnRoute)"
    >
      {{ $t('back-to-home') }}
    </Button>
  </div>
</template>
